<ng-template #content>
  @let icon = computedIcon();
  @if (icon.exists) {
    <evc-icon
      class="icon"
      [icon]="icon.name"
      [svgPath]="icon.path" />
  }
  <span
    class="content"
    #projectedContent>
    {{ text() }}
    <ng-content></ng-content>
  </span>
</ng-template>

@let linkStyle = computedStyles();

@if (href() || routerLink()) {
  @let linkTarget = rel() === buttonRels.EXTERNAL ? buttonTargets.BLANK : target();
  <a
    class="button"
    [attr.href]="href()"
    [attr.rel]="rel()"
    [target]="linkTarget"
    [attr.data-type]="linkStyle?.type"
    [attr.data-frame]="linkStyle?.frame"
    [attr.data-size]="size()"
    [routerLink]="routerLink()"
    [queryParams]="queryParams()"
    [attr.data-icon-position]="computedIcon().position"
    [attr.data-disabled]="disabled()"
    [attr.data-active]="isActive()"
    [attr.data-download]="download()"
    [attr.aria-label]="label()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <button
    class="button"
    [disabled]="disabled()"
    [attr.data-size]="size()"
    [attr.data-type]="linkStyle?.type"
    [attr.data-frame]="linkStyle?.frame"
    [attr.data-icon-position]="computedIcon().position"
    [attr.data-disabled]="disabled()"
    [attr.data-active]="isActive()"
    [attr.aria-label]="label()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}
